"use client"
import { useState, useEffect } from 'react';

const PWAInstallButton = () => {
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [showInstallButton, setShowInstallButton] = useState(false);
    const [isInstalled, setIsInstalled] = useState(false);

    useEffect(() => {
        // Check if the app is already installed
        const checkInstalled = () => {
            if (window.matchMedia('(display-mode: standalone)').matches) {
                setIsInstalled(true);
                return;
            }
            
            // Check for iOS Safari
            if (window.navigator.standalone === true) {
                setIsInstalled(true);
                return;
            }
        };

        checkInstalled();

        // Listen for the beforeinstallprompt event
        const handleBeforeInstallPrompt = (e) => {
            // Prevent the mini-infobar from appearing on mobile
            e.preventDefault();
            // Stash the event so it can be triggered later
            setDeferredPrompt(e);
            setShowInstallButton(true);
        };

        // Listen for the appinstalled event
        const handleAppInstalled = () => {
            setIsInstalled(true);
            setShowInstallButton(false);
            setDeferredPrompt(null);
        };

        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        window.addEventListener('appinstalled', handleAppInstalled);

        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
            window.removeEventListener('appinstalled', handleAppInstalled);
        };
    }, []);

    const handleInstallClick = async () => {
        if (!deferredPrompt) return;

        // Show the install prompt
        deferredPrompt.prompt();
        
        // Wait for the user to respond to the prompt
        const { outcome } = await deferredPrompt.userChoice;
        
        if (outcome === 'accepted') {
            console.log('User accepted the install prompt');
        } else {
            console.log('User dismissed the install prompt');
        }
        
        // Clear the deferredPrompt
        setDeferredPrompt(null);
        setShowInstallButton(false);
    };

    // Don't show anything if already installed or not available
    if (isInstalled || !showInstallButton) {
        return null;
    }

    return (
        <a 
            className='col-12 col-md-4 mb-3 mb-md-0' 
            onClick={handleInstallClick}
            style={{ cursor: 'pointer' }}
            title="تثبيت التطبيق على الجهاز"
        >
            <div className='img-fluid mx-auto border p-3 rounded-4 filter-invert d-flex flex-column align-items-center justify-content-center' 
                 style={{ minHeight: '80px', backgroundColor: '#f8f9fa' }}>
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="mb-2">
                    <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <small className="text-center" style={{ fontSize: '0.75rem', fontWeight: '500' }}>
                    تثبيت التطبيق
                </small>
            </div>
        </a>
    );
};

export default PWAInstallButton;
